import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faCircleXmark,
  faFaceGrinStars,
  faObjectGroup,
  faQuestionCircle,
  faTimesCircle,
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faCircleXmark,
  faObjectGroup,
  faFaceGrinStars,
  faQuestionCircle,
  faTimesCircle,
);
